module.exports = __webpack_public_path__ + "media/new-transaction.654e61c8.wav";